import React from 'react';
import { Button, Card, CardContent, Grid, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import DateRangeFilter, { getPresetDates } from '../../../components/DateRangeFilter';
import { useReporting } from '../ReportingContext';

const BlogFilters = () => {
  const {
    blogPreset,
    blogCategories,
    blogSelectedCategory,
    blogSelectedSubcategory,
    affiliates,
    selectedAffiliateId,
    viewAllAffiliates,
    setBlogPreset,
    setBlogDateDates,
    setBlogSelectedCategory,
    setBlogSelectedSubcategory,
    setSelectedAffiliateId,
    setViewAllAffiliates,
  } = useReporting();

  return (
  <Card sx={{ mb: 3 }}>
    <CardContent>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
        Filters
      </Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel>View Mode</InputLabel>
            <Select
              value={viewAllAffiliates ? 'all' : 'single'}
              label="View Mode"
              onChange={(e) => {
                const viewAll = e.target.value === 'all';
                setViewAllAffiliates(viewAll);
                if (!viewAll) {
                  setSelectedAffiliateId('');
                }
              }}
              size="small"
            >
              <MenuItem value="all">All Affiliates</MenuItem>
              <MenuItem value="single">Single Affiliate</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {!viewAllAffiliates && (
          <Grid item>
            <FormControl sx={{ minWidth: 250 }}>
              <InputLabel shrink>Affiliate</InputLabel>
              <Select
                value={selectedAffiliateId}
                label="Affiliate"
                displayEmpty
                notched
                onChange={(e) => setSelectedAffiliateId(e.target.value)}
                size="small"
              >
                <MenuItem value="">
                  <em>Select Affiliate</em>
                </MenuItem>
                {affiliates.map((affiliate) => (
                  <MenuItem key={affiliate._id} value={affiliate._id}>
                    {affiliate.name || affiliate.email} {affiliate.affiliateData?.name ? `(${affiliate.affiliateData.name})` : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        <Grid item>
          <DateRangeFilter
            label="Date Range"
            value={blogPreset}
            size="small"
            onChange={(dates, preset) => {
              setBlogPreset(preset);
              setBlogDateDates(dates);
            }}
          />
        </Grid>
        <Grid item>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel shrink>Category</InputLabel>
            <Select
              value={blogSelectedCategory}
              label="Category"
              displayEmpty
              notched
              onChange={(e) => {
                setBlogSelectedCategory(e.target.value);
                setBlogSelectedSubcategory('');
              }}
              size="small"
            >
              <MenuItem value="">
                <em>All Categories</em>
              </MenuItem>
              {blogCategories.map((category) => (
                <MenuItem key={category._id} value={category._id}>
                  {category.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl sx={{ minWidth: 200 }} disabled={!blogSelectedCategory}>
            <InputLabel shrink>Subcategory</InputLabel>
            <Select
              value={blogSelectedSubcategory}
              label="Subcategory"
              displayEmpty
              notched
              onChange={(e) => setBlogSelectedSubcategory(e.target.value)}
              size="small"
            >
              <MenuItem value="">
                <em>All Subcategories</em>
              </MenuItem>
              {blogSelectedCategory && blogCategories.find(c => c._id === blogSelectedCategory)?.subcategories?.map((sub) => (
                <MenuItem key={sub._id} value={sub._id}>
                  {sub.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {(blogSelectedCategory || blogSelectedSubcategory) && (
          <Grid item>
            <Button
              variant="outlined"
              onClick={() => {
                setBlogSelectedCategory('');
                setBlogSelectedSubcategory('');
              }}
              size="small"
            >
              Clear Filters
            </Button>
          </Grid>
        )}
      </Grid>
    </CardContent>
  </Card>

  );
};

export default BlogFilters;
